<div ngbDropdown class="inline-block" #drp="ngbDropdown">

  <!-- Trigger button — matches other filter controls -->
  <button ngbDropdownToggle type="button"
    class="inline-flex items-center gap-2 rounded-xl border border-n30 bg-white px-4 py-2.5
           text-sm text-n500 hover:border-b300 hover:text-n700 transition-colors whitespace-nowrap drp-toggle">
    <i class="ph ph-calendar-blank text-base leading-none text-n400"></i>
    <span *ngIf="fromControl.value; else placeholder">
      <span class="font-semibold text-b300" *ngIf="selectedRangeLabel">{{ selectedRangeLabel }} — </span>
      {{ fromControl.value | date:'MMM d' }} – {{ toControl.value | date:'MMM d, yyyy' }}
    </span>
    <ng-template #placeholder><span class="text-n400">Select date range</span></ng-template>
    <i class="ph ph-caret-down text-xs leading-none text-n400 ml-1"></i>
  </button>

  <!-- Calendar panel -->
  <div ngbDropdownMenu class="drp-panel">
    <ngx-daterangepicker-material
      [ranges]="ranges"
      [autoApply]="false"
      [showCustomRangeLabel]="true"
      [alwaysShowCalendars]="true"
      (datesUpdated)="choosedDate($event); drp.close()"
      (rangeClicked)="onRangeChanged($event); drp.close()">
    </ngx-daterangepicker-material>
  </div>

</div>
